<template>
  <q-card flat>
    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm">
        <select_hospInfo
          :dense="true"
          outlined
          class="col-2"
          label="选择机构"
          v-model="HospID"
          v-model:valueCode="HospID"
        />
        <ConfigKey_select
          :dense="true"
          outlined
          class="col-2"
          label="选择主模块"
          v-model="CONFIG_KEY_NO"
          v-model:valueCode="CONFIG_KEY_NO"
        />
        <q-btn
          color="primary"
          icon="search"
          @click="onLoadData"
          :loading="PdmConfigValuesListLoading"
          style="height: 38px;"
        >
          查询
        </q-btn>
        <q-space />
        <!-- <q-btn color="primary" icon="download" style="height: 38px;" @click="onDownload" :loading="WxHomeimageListLoading">
              下载
            </q-btn>
            <q-btn color="primary" style="height: 38px" icon="fas fa-file-excel" :loading="PdmConfigValuesListLoading" @click="onExportData">导出</q-btn> -->
        <q-btn
          color="primary"
          style="height: 38px"
          icon="note_add"
          :loading="PdmConfigValuesListLoading"
          @click="onAdd2"
          >一键模版添加</q-btn
        >
        <q-btn
          color="primary"
          style="height: 38px"
          icon="note_add"
          :loading="PdmConfigValuesListLoading"
          @click="onAdd"
          >单独添加</q-btn
        >
      </div>
      <vxe-grid
        v-bind="gridOptions"
        :sort-config="{ multiple: true }"
        :custom-config="{ storage: true }"
        id="custom-config"
        :export-config="gridOptions.tableExport"
        :height="$store.getters.maxPageHeight - 140"
        :loading="PdmConfigValuesListLoading"
        highlight-current-row
        size="mini"
      >
        <template #toolbar_buttons id="custom-config"> </template>
        <template #operate="{ row }">
          <vxe-button
            flat
            color="primary"
            icon="fas  fa-edit"
            @click="onEdit(row)"
            >编辑</vxe-button
          >
          <vxe-button
            flat
            color="negative"
            icon="fas fa-trash"
            @click="onDelete(row)"
            >删除</vxe-button
          >
        </template>
      </vxe-grid>
      <vxe-pager
        perfect
        size="mini"
        :page-sizes="tablePage.pageSizes"
        v-model:current-page="tablePage.currentPage"
        v-model:page-size="tablePage.pageSize"
        :total="tablePage.totalResult"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      >
      </vxe-pager>
    </q-card-section>
  </q-card>
  <div>
  <q-dialog v-model="pdmConfigValuesshowDlg" persistent>
    <ConfigValuesEdit @onLoadData="onLoadData" />
  </q-dialog>
  <q-dialog v-model="pdmConfigValuesShowDlg2" persistent>
    <AddConfigValues @onLoadData="onLoadData" />
  </q-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import XEUtils from "xe-utils";
import ConfigValuesEdit from "./configValuesEdit.vue";
import AddConfigValues from "./addConfigValues.vue";
import ConfigKey_select from "@/views/pdm/comm/configKey_select.vue";
import select_hospInfo from "@/views/pdm/comm/hospInfo_select.vue";
export default {
  components: {
    ConfigValuesEdit,
    AddConfigValues,
    ConfigKey_select,
    select_hospInfo,
  },
  computed: {
    ...mapState("WebConfig", ["WebConfigState"]),
    ...mapState("PdmConfigValues", [
      "PdmConfigValuesList",
      "PdmConfigValuesListLoading",
      "PdmConfigValuesEntity",
      "PdmConfigValuesShowDlg",
      "PdmConfigValuesShowDlg2",
    ]),

    pdmConfigValuesshowDlg: {
      get() {
        return this.PdmConfigValuesShowDlg;
      },
      set(val) {
        console.log(val);
        this.$store.commit("PdmConfigValues/setPdmConfigValuesShowDlg", val);
      },
    },
    pdmConfigValuesShowDlg2: {
      get() {
        return this.PdmConfigValuesShowDlg2;
      },
      set(val) {
        console.log(val);
        this.$store.commit("PdmConfigValues/setPdmConfigValuesShowDlg2", val);
      },
    },
  },
  watch: {
    WebConfigState(val) {
      if (val == 1) {
        setTimeout(() => {
          this.onLoadData();
          this.$store.commit("WebConfig/setWebConfigState", 0);
        }, 500);
      }
    },
  },
  data() {
    return {
      FilterString: "",
      HospID: null,
      CONFIG_KEY_NO: null,
      tablePage: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
        pageSizes: [15, 20, 50, 100, 5000],
      },
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        highlightHoverRow: true,
        align: "left",
        toolbarConfig: {
          perfect: true,
          print: true,
          zoom: true,
          custom: true,
          export: true,
          slots: {
            // 自定义工具栏模板
            buttons: "toolbar_buttons",
          },
        },
        //点击编辑必须配置
        // editConfig: {
        //   trigger: "click",
        //   mode: "cell",
        //   activeMethod: () => {
        //     if (this.lockData) return false;
        //     return true;
        //   },
        // },
        tableExport: {},
        columns: [
          { type: "seq", width: 50, align: "center" },
          {
            field: "HospName",
            title: "机构名称",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "CONFIG_KEY_NAME",
            title: "主模块名称",
            sortable: true,
            align: "center",
            width: 100,
          },
          {
            field: "CONFIG_VALUES_NAME",
            title: "布局模块名称",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "CONFIG_VALUES_TYPEname",
            title: "类别",
            sortable: true,
            align: "left",
            width: 100,
          },
          {
            field: "CONFIG_VALUES_TU",
            title: "布局模块图片",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "CONFIG_VALUES_NO",
            title: "排列序号",
            sortable: true,
            align: "center",
            width: 100,
          },
          {
            field: "CONFIG_VALUES_IS_SWITCH_Name",
            title: "是否启用",
            sortable: true,
            align: "center",
            width: 100,
          },
          {
            field: "IS_SHOW_Name",
            title: "是否展示",
            sortable: true,
            align: "center",
            width: 100,
          },
          {
            field: "CONFIG_VALUES_PATH",
            title: "小程序跳转路径",
            sortable: true,
            align: "left",
            width: 200,
          },
          {
            field: "CDATE",
            title: "创建时间",
            sortable: true,
            align: "center",
            width: 160,
          },
          {
            title: "操作",
            width: 200,
            slots: { default: "operate" },
            align: "center",
            fixed: "right",
          },
          //   {
          //     field: "CatName",
          //     title: "类别",
          //     sortable: true,
          //     editRender: { name: "input" },//点击编辑必须配置
          //     slots: { edit: "CatName" },//点击编辑必须配置
          //     align: "left",
          //     width: 140,
          //   },
        ],
        // data: this.PdmConfigValuesList,
        data: null,
      },
    };
  },
  mounted() {
    this.onLoadData();
  },
  methods: {
    ...mapActions("PdmConfigValues", [
      "actGetPdmConfigValuesListByPage",
      "actCreatePdmConfigValues",
      "actEditPdmConfigValuesData",
      "actEditPdmConfigValues",
      "actDeletePdmConfigValues",
    ]),
    onLoadData() {
      this.actGetPdmConfigValuesListByPage({
        HospID: this.HospID,
        CONFIG_KEY_NO: this.CONFIG_KEY_NO,
        FilterString: this.FilterString,
        PageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
      })
        .then((res) => {
          this.gridOptions.data = res.Data;
          this.tablePage.totalResult = res.Count;
        })
        .finally(() => {
          this.$store.commit(
            "PdmConfigValues/setPdmConfigValuesListLoading",
            false
          );
          //this.PdmConfigValuesListLoading = false;
        });
    },
    onAdd() {
      this.actCreatePdmConfigValues({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
      });
    },
    onAdd2() {
      this.$store.commit("PdmConfigValues/setPdmConfigValuesShowDlg2", true);
    },
    onEdit(e) {
      var obj = {};
      Object.assign(obj, e);
      this.actEditPdmConfigValues(obj);
    },
    onDelete(e) {
      this.actDeletePdmConfigValues({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: e,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
        }
      });
    },
    //onExportData:{},
    //需要合计：表头必须添加 :footer-method="footerMethod" 跟 show-footer
    footerMethod({ columns, data }) {
      var list = ["PRIC"]; //需要汇总的字段
      const footerData = [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (list.includes(column.property)) {
            return XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
      return footerData;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.onLoadData();
    },
  },
};
</script>
